import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-encapsulate-view',
  templateUrl: './encapsulate-view.component.html',
  styleUrl: './encapsulate-view.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class EncapsulateViewComponent {

}
